import { T } from '@app/components/translation';

export const CONTENT_TRUNCATE_LENGTH = 100;
export const CONTENT_TRUNCATE_NEWLINE_COUNT = 5;
export const CONTENT_TRUNCATE_NEWLINE_COUNT_MOBILE = 2;

export const showMoreLabel = (
  <T
    _str="Show more"
    _comment="show more content of text', used as button text."
  />
);

export const showLessLabel = (
  <T
    _str="Show less"
    _comment="show less content of text', used as button text."
  />
);

export const isContentTooLong = (content: string) => {
  if (!content) {
    return false;
  }

  const newlines = content.match(/\n/g);

  return (
    content.length > CONTENT_TRUNCATE_LENGTH + 50 ||
    (newlines && newlines.length > CONTENT_TRUNCATE_NEWLINE_COUNT)
  );
};
